export default "__VITE_ASSET__d97d9064__"